export { SuiProgressModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/progress/public.js
// module id = 1114
// module chunks = 0